import React from 'react';
import { CalendarDays } from 'lucide-react';

export const SchedulingStepEmptyState: React.FC = () => {
  return (
    <div className='flex flex-col items-center h-full py-12 px-4 text-center'>
      <div className='bg-gray-50 p-4 rounded-full mb-4'>
        <CalendarDays className='h-8 w-8 text-gray-400' />
      </div>
      <h3 className='text-lg font-medium text-gray-900'>
        No Scheduling Selection Made
      </h3>
      <p className='text-sm text-gray-500 mt-1 max-w-sm'>
        Toggle one of the checkboxes above to decide whether to schedule a
        visit.
      </p>
    </div>
  );
};
